/* Optional in-page notes. No network, storage, classification, sizing, or checkout side effects. */
(() => {
  'use strict';
  document.querySelectorAll('[data-door-guide] [data-guide-notes]').forEach((panel) => {
    const build = panel.querySelector('[data-guide-build]');
    const output = panel.querySelector('[data-guide-output]');
    const wrap = panel.querySelector('[data-guide-output-wrap]');
    const copy = panel.querySelector('[data-guide-copy]');
    const status = panel.querySelector('[data-guide-status]');
    if (!build || !output || !wrap || !copy || !status) return;
    build.hidden = false;
    build.addEventListener('click', () => {
      const values = Array.from(panel.querySelectorAll('[data-note]'), (field) => `${field.dataset.note}: ${field.value.trim() || 'Not recorded'}`);
      output.value = ['My fireplace door notes', ...values, '', 'Opening measurements / preferences only. Finished door size and compatibility need review.'].join('\n');
      wrap.hidden = false;
      status.textContent = 'Notes ready. Review them before sharing.';
      output.focus({ preventScroll: true });
    });
    copy.addEventListener('click', async () => {
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(output.value);
        status.textContent = 'Copied. Paste these notes into your email or consultation notes.';
      } catch (_) {
        output.focus(); output.select();
        status.textContent = 'Your notes are selected. Use your device’s Copy command.';
      }
    });
  });
})();

/* In-page image detail, with ordinary image-link fallback. */
(() => {
  const links = document.querySelectorAll('.efguide [data-guide-zoom]');
  if (!links.length || !('HTMLDialogElement' in window)) return;
  const dialog = document.createElement('dialog'); dialog.className = 'efguide-zoom-dialog';
  dialog.setAttribute('aria-labelledby', 'efguide-zoom-title');
  dialog.innerHTML = '<header><h2 id="efguide-zoom-title"></h2><button type="button" aria-label="Close enlarged image">×</button></header><img alt=""><p></p>';
  document.body.append(dialog); let origin;
  links.forEach(link => link.addEventListener('click', event => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (typeof dialog.showModal !== 'function') return;
    event.preventDefault(); origin = link;
    const img = dialog.querySelector('img'); img.src = link.href; img.alt = link.dataset.guideTitle;
    dialog.querySelector('h2').textContent = link.dataset.guideTitle;
    dialog.querySelector('p').textContent = link.closest('figure').querySelector('figcaption').textContent;
    dialog.showModal(); dialog.querySelector('button').focus();
  }));
  dialog.querySelector('button').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {if (event.target !== dialog) return; const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();});
  dialog.addEventListener('close', () => origin?.focus({preventScroll:true}));
})();
